import { render, staticRenderFns } from "./SuperAdminNavigation.vue?vue&type=template&id=7f9cf6f4&scoped=true"
import script from "./SuperAdminNavigation.vue?vue&type=script&lang=js"
export * from "./SuperAdminNavigation.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminNavigation.vue?vue&type=style&index=0&id=7f9cf6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9cf6f4",
  null
  
)

export default component.exports